import { useState, useRef, useEffect } from "react";
import axios from "axios";

const API_BASE = "https://parentaibackend-production.up.railway.app";
const sessionKey = localStorage.getItem("tofuBetaSessionKey");

let userId = localStorage.getItem("tofuUserId");
if (!userId) {
  userId = crypto.randomUUID();
  localStorage.setItem("tofuUserId", userId);
}

export function useChatSession() {
  const [messages, setMessages] = useState([]);
  const [typingMessage, setTypingMessage] = useState(null);
  const [isAItyping, setIsAItyping] = useState(false);

  const typingIntervalRef = useRef(null);

  const typeSmooth = (fullText, sources) => {
    if (typingIntervalRef.current) clearInterval(typingIntervalRef.current);

    setTypingMessage({
      sender: "ai",
      text: "",
      fullText,
      timestamp: new Date().toISOString(),
      sources,
    });

    let i = 0;
    setIsAItyping(true);

    typingIntervalRef.current = setInterval(() => {
      setTypingMessage((prev) => {
        if (!prev) return null;
        const nextText = fullText.slice(0, i + 1);
        i++;
        return { ...prev, text: nextText };
      });

      if (i >= fullText.length) {
        clearInterval(typingIntervalRef.current);
        setIsAItyping(false);
      }
    }, 12);
  };

  useEffect(() => {
    if (!typingMessage) return;
    if (typingMessage.text === typingMessage.fullText) {
      setMessages((prev) => [...prev, typingMessage]);
      setTypingMessage(null);
    }
  }, [typingMessage]);

  const sendMessage = async (input) => {
    if (!input.trim()) return;

    const userMsg = {
      sender: "user",
      text: input,
      timestamp: new Date().toISOString(),
    };
    setMessages((prev) => [...prev, userMsg]);

    try {        
        if (!sessionKey) {
          window.location.hash = "#/beta";
          return;
        }

        const res = await axios.post(
          `${API_BASE}/chat`,
          { user_input: input, user_id: userId },
          {
            headers: sessionKey ? { Authorization: `Bearer ${sessionKey}` } : {},
          }
        );
      typeSmooth(res.data.answer, res.data.sources || []);
    } catch {
      setMessages((prev) => [
        ...prev,
        {
          sender: "ai",
          text: "I'm sorry — something went wrong.",
          timestamp: new Date().toISOString(),
        },
      ]);
    }
  };

  return {
    messages,
    typingMessage,
    isAItyping,
    sendMessage,
  };
}